// extracted by mini-css-extract-plugin
module.exports = {"root":"AddressFilterToggle_root__7IQe3","container":"AddressFilterToggle_container__3mGCV","btnWrap":"AddressFilterToggle_btnWrap__1P9zP","icon":"AddressFilterToggle_icon__2IF65"};